<div class="container">
  <ul class="account-details-nav ps-0">
    <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'account.nav.profile' | translate }}</label>
    </a>
    <a class="nav-item" [routerLink]="['/badges']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'accounts.nav.badges' | translate }}</label>
    </a>
    <a class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'account.nav.activity' | translate }}</label>
    </a>
  </ul>
</div>
